import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { HttpMethod } from "../../Asset/httpMethod";
import {
  startLoader,
  stopLoader,
} from "../../Redux/Slices/Utility/loaderSlice";

const ConfirmEmail = () => {
  const dispatch = useDispatch();
  const [msg, setMsg] = useState("");
  const [btnDisabled, setBtnDisabled] = useState(false);

  // const decodedSearch = decodeURIComponent(window.location.search);
  // const query = new URLSearchParams(decodedSearch.replace(/&amp;/g, "&"));
  // const emailid = query.get('email');
  // const token = query.get('token');

  // const rawToken = window.location.search.match(/token=([^&]+)/)?.[1] || "";
  // const emailParam = window.location.search.match(/email=([^&]+)/)?.[1] || "";

  // const query = new URLSearchParams(window.location.search.replace(/&amp;/g, "&"));
  // const emailid = query.get("email");
  // const token = query.get("token");

  const [emailid, setEmailid] = useState("");
  const [token, setToken] = useState("");
  // ✅ Get token as-is (encoded)
  useEffect(() => {
    // Do not decode — extract raw token
    const rawToken = window.location.search.match(/token=([^&]+)/)?.[1] || "";
    const emailParam = window.location.search.match(/email=([^&]+)/)?.[1] || "";
    setEmailid(decodeURIComponent(emailParam)); // Decode only email
    setToken(rawToken); // Leave token URL-encoded
  }, []);

  const handleConfirmClick = async () => {
    if (!emailid || !token) {
      setMsg("Invalid confirmation link.");
      return;
    }

    try {

      dispatch(startLoader());
      setBtnDisabled(true);

      await HttpMethod.post("/Authorization/Account/ConfirmEmail", {
        Email: emailid.trim(),
        Token: token.trim(),
      });
      setMsg("Email confirmed successfully!");
    } catch (err) {
      setMsg(err.response?.data || "Email confirmation failed");
    } finally {
      dispatch(stopLoader());
      setBtnDisabled(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box text-center">
        <div className="d-flex justify-content-center">
          <button
            className="savepanelBtn btn-primary w-50 mt-3"
            type="button"
            onClick={handleConfirmClick}
            disabled={btnDisabled}
          >
            {btnDisabled ? "Confirming..." : "Confirm Email"}
          </button>
        </div>
        <p className="mt-4">{msg}</p>
      </div>
    </div>
  );
};

export default ConfirmEmail;
